var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataTable',{attrs:{"title":"Position Recommendations History","show_delete":false,"show_header_filter":false,"fields":_vm.fields,"response":_vm.response},on:{"edit_click":_vm.viewSession}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }